class StaticPageController {
  constructor($scope, page) {
    $scope.page = page.data;
  }
}

StaticPageController.$inject = ['$scope', 'page'];

export default StaticPageController;
